module.exports = __webpack_public_path__ + "img/dots_rtb4.24df2284.png";